export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_Spanish - Corporate - Horizontal - White.72f6a75d.svg";